import { put } from "redux-saga/effects";
import {
  login,
  loginv2,
  verifyOtp,
  changePassword,
  forgotPassword,
  getCaptcha,
  verifyCaptcha,
} from "../../Services";

export function* loginSaga(action) {
  const payload = action.payload;

  try {
    const res = yield login(payload.data);
    if (res.data.name) {
      if (res.data.name === "SequelizeConnectionError") {
        payload.cb(false);
        yield put({ type: "REQ_LOGIN_FAILED", errData: res.data });
      }
    } else {
      localStorage.setItem("Authorization", res.headers.authorization);
      localStorage.setItem("LoginData", JSON.stringify(res.data));
      payload.cb(true);
      yield put({ type: "REQ_LOGIN_SUCCEEDED", data: res.data });
    }
  } catch (e) {
    payload.cb(false);
    yield put({ type: "REQ_LOGIN_FAILED", errData: e });
  }
}

// export function* loginV2Saga(action) {
//   const { payload } = action;
//   try {
//     const res = yield loginv2(payload.data);
//     if (!res.data.name) {
//       payload.cb(true);
//       yield put({ type: "REQ_LOGIN_V2_SUCCEEDED", data: res.data });
//     }
//     payload.cb(false);
//     yield put({ type: "REQ_LOGIN_V2_FAILED", errData: res.data });
//   } catch (e) {
//     payload.cb(false);
//     yield put({ type: "REQ_LOGIN_V2_FAILED", errData: e });
//   }
// }

export function* verifyOtpSaga(action) {
  const { payload } = action;
  try {
    const res = yield verifyOtp(payload);
    if (!res.data.name) {
      payload.cb(true);
      yield put({ type: "VERIFY_OTP_SUCCEEDED", data: res.data });
    }

    payload.cb(false);
    yield put({ type: "VERIFY_OTP_FAILED", data: res.data });
  } catch (e) {
    payload.cb(false);
    yield put({ type: "VERIFY_OTP_FAILED", data: e });
  }
}

export function* logoutSaga(action) {
  const { payload } = action;
  try {
    localStorage.removeItem("Authorization");
    localStorage.removeItem("LoginData");

    yield put({ type: "REQ_LOGOUT_SUCCEEDED", data: payload });
  } catch (e) {
    console.log("LOGOUT GAGAL");
  }
}

export function* changePasswordSaga(action) {
  const { payload } = action;
  try {
    const res = yield changePassword(payload);
    yield put({ type: "REQ_CHANGE_PASSWORD_SUCCEEDED", data: res });
  } catch (e) {
    yield put({ type: "REQ_CHANGE_PASSWORD_FAILED", errData: e });
  }
}

export function* forgotPasswordSaga(action) {
  console.log("masuk forgot password...", action);
  const { payload } = action;
  try {
    const res = yield forgotPassword(payload);
    console.log("res....", res);
    yield put({ type: "REQ_FORGOT_PASSWORD_SUCCEEDED", data: res });
  } catch (e) {
    console.log("error saga...", e);
    yield put({ type: "REQ_FORGOT_PASSWORD_FAILED", errData: e });
  }
}

export function* getCaptchaSaga(_) {
  try {
    const res = yield getCaptcha();
    yield put({ type: "REQ_CAPTCHA_SVG_SUCCEEDED", data: res });
  } catch (e) {
    yield put({ type: "REQ_CAPTCHA_SVG_FAILED", errData: e });
  }
}

export function* verifyCaptchaSaga(action) {
  const { payload } = action;
  try {
    const res = yield verifyCaptcha(payload);
    if (res.data) {
      yield put({ type: "VERIFY_CAPTCHA_SVG_REQUEST_SUCCEEDED", data: res });
    } else {
      yield put({ type: "VERIFY_CAPTCHA_SVG_REQUEST_FAILED", errData: res });
    }
  } catch (e) {
    yield put({ type: "VERIFY_CAPTCHA_SVG_REQUEST_FAILED", errData: e });
  }
}
